import React from "react";
// my-space/pagesMap.ts
import { FaUser, FaFileContract, FaRegClock } from "react-icons/fa";
import { PiMountains } from "react-icons/pi";
import { MdNotificationsNone } from "react-icons/md";
import { BsWallet2 } from "react-icons/bs";

import MySpaceEngineerContracts from "./engineer/my-space-engineer-contracts";
import MySpaceEngineerProfile from "./engineer/my-space-engineer-profile";
import MySpaceProfile from "./buy/my-space-profile";
import MySpaceSellerProfile from "./seller/my-space-profile";

import EngineerReportRequests from "./engineer/my-space-engineer-notifications";
import MySpaceEngineerProperty from "./engineer/my-space-engineer-property";
import MySpaceNotifications from "./seller/my-space-notifications";

import MySpaceBank from "./buy/my-space-bank";
import MySpaceBankData from "./seller/my-space-bank";
import MySpaceProperty from "./buy/my-space-property";
import MySpaceSellerProperty from "./seller/my-space-property";
// Páginas específicas

type UserRole = "buyer" | "seller" | "engineer";
type PageComponent = React.ComponentType<any>;

interface PageEntry {
  id: string;
  labelKey: string;
  roles: UserRole[];
  icon: () => JSX.Element;
  component: Record<UserRole, PageComponent | null>;
}

export const mySpacePages: PageEntry[] = [
  {
    id: "profile",
    labelKey: "profile",
    roles: ["buyer", "seller", "engineer"],
    icon: () => <FaUser color="#50700F" />,
    component: {
      buyer: MySpaceProfile,
      seller: MySpaceSellerProfile,
      engineer: MySpaceEngineerProfile,
    },
  },
  {
    id: "property",
    labelKey: "my-properties",
    roles: ["buyer", "seller", "engineer"],
    icon: () => <PiMountains color="#50700F" />,
    component: {
      buyer: MySpaceProperty,
      seller: MySpaceSellerProperty,
      engineer: MySpaceEngineerProperty,
    },
  },
    {
    id: "contracts",
    labelKey: "contracts",
    roles: ["engineer"],
    icon: () => <FaFileContract color="#50700F" />,
    component: {
      buyer: null,
      seller: null,
      engineer: MySpaceEngineerContracts,
    },
  },
  {
    id: "my-notifications",
    labelKey: "notifications",
    roles: ["buyer", "seller", "engineer"],
    icon: () => <MdNotificationsNone color="#50700F" />,
    component: {
      buyer: MySpaceNotifications,
      seller: MySpaceNotifications,
      engineer: MySpaceNotifications,
    },
  },
  {
    id: "visit-requests",
    labelKey: "visit-requests",
    roles: ["engineer"],
    icon: () => <FaRegClock color="#50700F" />,
    component: {
      buyer: null,
      seller: null,
      engineer: EngineerReportRequests,
    },
  },
  {
    id: "bank-data",
    labelKey: "bank-data",
    roles: ["seller", "buyer"],
    icon: () => <BsWallet2 color="#50700F" />,
    component: {
      buyer: MySpaceBankData,
      seller: MySpaceBankData,
      engineer: null,
    },
  },
];
